import React, { useEffect } from "react"
import { Check, X } from "lucide-react"
import { cn, OPERATORS, queryTools } from "lib/utils" 


function ItemBlock({ refid, items=[], zonereport }:{ refid:string; items:any[], zonereport }){

  const item = items.find( (item:any) => item.refid === refid )

  useEffect(() => {
    console.log("zonereport", zonereport)
  },[ zonereport ])

  if( !item ) return <></>
  return (
    <div className="w-full flex justify-start items-start gap-2 *:text-xs">
      { zonereport?.items.passed.includes(refid) && <Check className="size-4 stroke-1 stroke-green-500" /> }
      { zonereport?.items.failed.includes(refid) && <X className="size-4 stroke-1 stroke-red-500" /> }
      <div className="w-full">
        <span className="pr-1">{ item.apiValueObj?.label }</span>
        <span className="pr-1">{ OPERATORS.find( (op:any) => op.value === item.operator )?.label }</span>
        <span>{item.value}</span>
      </div>
    </div>
  )
}




export default function ConditionalSummary({
  conditional,
  report
}:{
  conditional:any
  report:any
}){

  // const { data: _ApiData } = queryTools.resource.parseQueryForApi("apidata.findAll", { }, { enabled: true })

  return (
    <div className="w-full flex flex-col gap-1">
      { conditional?.zones.map( (zone:any) => (
        <div 
          key={zone.zoneref} 
          className="w-full flex flex-wrap gap-x-1 gap-y-2"
        >
          { zone.groups.map( (group:any) => (
            <div key={group.groupref} className="flex gap-1">
              { group.items.map( (refid:any, idx:number) => (
                <div key={refid}>
                  <ItemBlock 
                    refid={refid} 
                    items={conditional.items} 
                    zonereport={ report?.zones.find( (z:any) => z.zoneref === zone.zoneref ) }
                  />
                  { idx < group.items.length - 1 && (
                    <span className="text-xs px-[3px]"> OR </span>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}